// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"03ad6015","3613":"03ad6015","4150":"7c7a0829","4504":"03ad6015","7845":"840d02f6","8679":"03ad6015"}[chunkId] + ".chunk.css";
};